export const TABLE_PAGE_SIZE = 20;

export const DON_HANG_TABLE_TABS = [
  { name: 'Tất cả' },
  { name: 'Lập chứng từ', status: '0', color: '#EAD1DC' },
  { name: 'Chờ duyệt', status: '1', color: '#ef4444' },
  { name: 'Đã duyệt', status: '5', color: '#3D85C6' },
  { name: 'Khác', status: '99', color: '#000000' }
] as const;
